import {useGetCompoundMappings} from './use-get-compound-mappings'
import {CompoundMappingType} from '@cypro/engine/database/schema'

/**
 * Returns the active `compound_mappings` row for a resource (matched by
 * `(mappingType, sourceId)`), or undefined when none exists. Wrapped in a hook so
 * resource forms can seed their machine id without repeating the find logic.
 */
export function useGetExistingCompoundMapping(mappingType: CompoundMappingType, sourceId: string | undefined) {
  const [mappings] = useGetCompoundMappings({mappingType})
  return (mappings ?? []).find(m => m.sourceId === sourceId)
}
